import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/core/services/store'
import ApiService from '@/core/services/api.service'
// import VueSocketIO from 'vue-socket.io'
// import SocketIO from "socket.io-client";

// import i18n internationalization plugin
import i18n from '@/core/plugins/vue-i18n'

Vue.config.productionTip = false

// Vue.use(new VueSocketIO({
//   debug: true,
//   connection: SocketIO('ws://10.100.0.122/v2/tests/broadcast', {
//     // auth: {
//     //   token: "123"
//     // },
//     // query: {
//     //   "my-key": "my-value"
//     // }
//   }),
//   vuex: {
//     store,
//     actionPrefix: "SOCKET_",
//     mutationPrefix: "SOCKET_"
//   }
// })
// );

// Global 3rd party plugins
import 'popper.js'
import 'tooltip.js'
import PerfectScrollbar from 'perfect-scrollbar'
window.PerfectScrollbar = PerfectScrollbar
import ClipboardJS from 'clipboard'
window.ClipboardJS = ClipboardJS

// Vue 3rd party plugins
import vuetify from '@/core/plugins/vuetify'
import '@/core/plugins/portal-vue'
import '@/core/plugins/bootstrap-vue'
import '@/core/plugins/perfect-scrollbar'
import '@/core/plugins/highlight-js'
import '@/core/plugins/inline-svg'
import '@/core/plugins/apexcharts'
import '@/core/plugins/metronic'
import '@mdi/font/css/materialdesignicons.css'
import '@/core/plugins/vuetags'
// import '@/core/plugins/socket-config'
import '@/core/plugins/viewer'

// Global Component Registration
import '@/core/plugins/globalRegistration'
import '@/core/plugins/prototypeRegistration'
import '@/core/plugins/directiveRegistration'

// API service init
ApiService.init()

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
